import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-wallet.svg";
import * as styles from "./Icon.module.scss";

type WalletProps = React.SVGProps<SVGSVGElement>;

export const Wallet = ({ className, ...props }: WalletProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
